module.exports = __webpack_public_path__ + "static/media/a2.a27d2de2.jpg";